import http from '@/utils/http'

export function login(data){
    return http.post('/sessions',data)
}
export function recaptcha(data){
    return http.post('/recaptcha',data)
}
export function logout(params){
    return http.delete('/sessions',{params})
}
export function refreshAccessToken(params){
    return http.get('/access_token',{params})
}